export default __webpack_public_path__ + "static/media/csv.d5e63aa2.svg";